
Greenmile.EventNotifications = Greenmile.EventNotifications || {};
Greenmile.EventNotifications.Route = Greenmile.EventNotifications.Route || {};
Greenmile.EventNotifications.Route.TableView = Greenmile.EventNotifications.Route.TableView || {};

Greenmile.EventNotifications.Route.TableView = (function () {

    function RouteTableView(route, eventId) {

        this.getRouteTabContent = () => {
            const allContent = document.createElement('div');
            allContent.className = 'routeTableViewContent';

            const routeSumary = document.createElement('div');
            routeSumary.className = 'EventNotificationTabHeader routeSumary';

            const date = Monet.Format.Date.formatToLocale(route.date);
            const items = [{ label: 'EventNotification.route.key', value: route.key },
                { label: 'EventNotification.route.date', value: date },
                { label: 'EventNotification.route.organization', value: route.organization.description }
            ];

            for (let i = 0, length = items.length; i < length; i++) {
                const item = items[i];
                const label = document.createElement('label');
                label.innerHTML = Monet.I18n.getResourcesByKey(item.label);
                label.className = 'routeSumaryLabel';
                const span = document.createElement('span');
                const value = Monet.I18n.getResourcesByKey(item.value);
                span.setAttribute('cellvalue', item.value);
                span.innerHTML = value;
                span.className = 'routeSumaryValue';

                label.appendChild(span);
                routeSumary.appendChild(label);
            }

            const info = [
                getStartRouteLine(),
                getDepartOriginLine(),
                getArriveDestinationLine(),
                getCompleteRouteLine()
            ];

            const grid = new Greenmile.UI.TimeTableView(info);

            allContent.appendChild(routeSumary);
            allContent.appendChild(grid.render());

            const cellKey = routeSumary.querySelector('[cellvalue="' + route.key + '"]');
            cellKey.innerHTML = route.key;

            return allContent;

        };

        function getStartRouteLine () {
            return {
                label: 'notificationPanel.start',
                planned: route.plannedStart,
                projected: route.projectedStart,
                actual: route.actualStart
            };
        }

        function getDepartOriginLine () {
            return {
                label: 'notificationPanel.depart',
                planned: route.plannedDeparture,
                projected: route.projectedDeparture,
                actual: route.actualDeparture
            };
        }

        function getArriveDestinationLine () {
            return {
                label: 'notificationPanel.arrive',
                planned: route.plannedArrival,
                projected: route.projectedArrival,
                actual: route.actualArrival
            };
        }

        function getCompleteRouteLine () {
            return {
                label: 'notificationPanel.complete',
                planned: route.plannedComplete,
                projected: route.projectedComplete,
                actual: route.actualComplete
            };
        }

    }

    return RouteTableView;

})();
